import React from 'react'

export default ({
  className = ''
}) => (
<svg className={className} xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 62.563 62.563"><path d="M38.5-60.156l-1.278.827-30,19.551V2.406H69.781V-39.778l-30-19.551Zm0,5.715L63.014-38.5,38.5-22.634,13.986-38.5ZM12.031-34.063l25.19,16.317,1.278.827L64.969-34.063V-2.406H12.031Z" transform="translate(-7.219 60.156)"/></svg>
  )
